// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-7fe16ecc]{display:none}.sf-badge[data-v-7fe16ecc]{--badge-background:#ea0c27;--badge-padding:0;display:flex;justify-content:center;align-items:center;border-radius:50%}.large[data-v-7fe16ecc]{--badge-width:64px;--badge-height:64px}.small[data-v-7fe16ecc]{--badge-width:40px;--badge-height:40px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
